import classNames from 'classnames';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function LoadingLink() {
  return (
    <div
      className={classNames(
        'flex',
        'w-full',
        'text-black',
        'rounded',
        'bg-white',
        'shadow',
        'flex-col',
        'sm:flex-row',
      )}
    >
      <div className={classNames('m-4', 'sm:w-1/3')}>
        <Skeleton height={160} />
      </div>
      <div
        className={classNames(
          'flex-1',
          'flex',
          'flex-col',
          'items-center',
          'justify-between',
          'p-4',
          'sm:items-start',
        )}
      >
        <p
          className={classNames(
            'text-center',
            'text-lg',
            'sm:text-left',
            'w-4/12',
          )}
        >
          <Skeleton />
        </p>
        <p
          className={classNames(
            'hidden',
            'text-sm',
            'sm:line-clamp-3',
            '[word-break:normal]',
            '[overflow-wrap:anywhere]',
            'w-full',
          )}
        >
          <Skeleton count={3} />
        </p>
        <p className="w-3/12">
          <Skeleton />
        </p>
      </div>
    </div>
  );
}
